module.exports = __webpack_public_path__ + "images/category_lp/earphone/new/assessment_achievements/5_fa71374977ca12fe9f64b4c6e3791564.png";